export const CompanyCode = "0391";
export const AEM_IMAGE_URL = process.env.AEM_IMAGE_URL;
